import React from 'react';

export default class CardsTableHeader extends React.Component {
  render() {
    const { showActions } = this.props;
    return (
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Age Ranges</th>
          <th>Skills</th>
          <th>Domains</th>
          {showActions && <th>Actions</th>}
          <th></th>
        </tr>
      </thead>
    );
  }
}
